module.exports = __webpack_public_path__ + "media/warranty-claim/photos-fasteners3-4d580708.png";